import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { convertPxToVw } from 'utils/helpers';
import { FieldBBType } from '../fields/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const searchField = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.SEARCH_FIELD>): CreatedBuildingBlock<typeof COMPONENT_TYPE.SEARCH_FIELD> =>
	createModel({
		type: COMPONENT_TYPE.SEARCH_FIELD,
		componentProps: {
			[UNIFORM_PROPS.fieldType]: FieldBBType.search,
			[UNIFORM_PROPS.fieldPlaceholder]: dictionary.SEARCH_FIELD.placeholder.text,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
					},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE]: {
						fontSize: convertPxToVw(20, 2, 375),
						height: convertPxToVw(50, 2, 375),
						paddingBottom: convertPxToVw(6, 2, 375),
						paddingLeft: convertPxToVw(6, 2, 375),
						paddingRight: convertPxToVw(18, 2, 375),
						paddingTop: convertPxToVw(6, 2, 375),
						width: convertPxToVw(300, 2, 375),
					},
				},
			},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SEARCH_FIELD>;
